export const redirectTo = (url: string) => {
  window.location.replace(url);
};
